/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cancel': {
    width: 6,
    height: 6,
    viewBox: '0 0 6 6',
    data: '<path pid="0" _fill="#376F99" fill-rule="nonzero" d="M1.302.044L.458.885 2.282 2.71.458 4.535l.844.842 1.824-1.824L4.95 5.377l.844-.842L3.97 2.71 5.794.885 4.95.044 3.126 1.868z"/>'
  }
})
